import type { Session as NextAuthSession } from 'next-auth';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AnsweredTicketMV } from 'abi-genome-common-types';

import { mountAuthHeaders } from '~/shared/auth/mountAuthHeaders';
import { genomeApi } from '~/shared/services/api';

export const GET_TICKET_QUERY_KEY = 'useGetTicket';

export type GetTicketsAPIResponse = AnsweredTicketMV;

export async function getTicket(
  ticketId: AnsweredTicketMV['id'],
  session?: NextAuthSession | null
) {
  const response = await genomeApi.get<AnsweredTicketMV>(
    `/ticket/${ticketId}`,
    {
      headers: mountAuthHeaders(session),
    }
  );

  return response.data;
}

export function useGetTicket<T = GetTicketsAPIResponse>(
  ticketId: AnsweredTicketMV['id'],
  queryOptions?: UseQueryOptions<
    AnsweredTicketMV,
    unknown,
    T,
    [string, AnsweredTicketMV['id']]
  >
) {
  return useQuery({
    queryKey: [GET_TICKET_QUERY_KEY, ticketId],
    queryFn: () => getTicket(ticketId),
    ...queryOptions,
  });
}
